<template>
  <div id="cardProduct-big-two" v-if="this.lodging">
    <portal to="modals">
      <div v-if="showMap && showOnMap && markers.length > 0" class="mobile-map-modal">
        <Maplodgingshow :key="`map-show-${lodging.id}`" v-if="showMap" :markers="markers" :selected-lodging="lodging"
            :nearby-lodgings="lodgings" @close="closeMap"></Maplodgingshow>
          </div>
    </portal>
    <div class="hub-img-zoom zoom-img-container" @click="goToLodging()" v-if="this.lodging.photo_banner">
      <div class="sticker-hub d-flex mt-4 pl-2">
        <img :src="greenNotePicto((this.lodging.score).toFixed())" :alt="(this.lodging.score).toFixed()" v-if="this.lodging.score">
        <div class="sticker-info d-flex" v-if="this.lodging.score">
          <p class="raleway-reg-p13 mb-0 pl-1 pr-2"> <b>{{ (this.lodging.score).toFixed() }}</b>/10</p>
          <p class="raleway-reg-p13 mb-0 pl-1 pr-2">Green note</p>
        </div>
      </div>
      <div class="position-relative">
        <img :src="formatSource()" v-set-alt class="hub-img zoom-img no-translate" :alt="this.lodging.name">
        <div class="image-gradient-bottom"></div>
        <div class="experience-name-text merriweather-reg-24 no-translate" v-if="this.experienceName">
          {{ this.experienceName[0] }} <br>
          <span class="merriweather-bold-italic-24 no-translate">{{ this.experienceName[1] }}</span>
        </div>
      </div> 
      <!-- <img class="hub-img" :src="formatSource()" :alt="this.lodging.name" v-if='this.photo_keys'> -->
    </div>
    <div class="card-hub-info pt-2" @click="goToLodging()">
      <!-- Discount Badges -->
      <CardDiscountBadges v-if="showDiscountBadges && lodging.lodging_discounts && lodging.lodging_discounts.length > 0" :lodging="lodging" />
      
      <div class="reviews-btn">
        <div class="hub-reviews d-flex">
          <div>
            <div class="d-flex align-items-baseline">
              <span class="merriweather-reg-16 no-translate">{{this.lodging.name}}</span>
              <div class="standing ml-1">
                <i class="fa-regular fa-star ml-1" v-if="parseInt(lodging.standing)" v-for="i in Math.max(0, parseInt(lodging.standing) || 0)" :key="i"></i>
                <img src="../../images/blanc.png" v-set-alt />
              </div>
            </div>
            <div class="map-area mb-2" v-if="showOnMap">
              <img src="../../images/Localisation.svg" v-set-alt style="margin-right: 5px" />
              <a class="link-hortense" @click.stop="displayMap">Voir sur la carte</a>
            </div>
            <p class="raleway-medi-p15" style="margin-bottom: 0rem; color: rgba(0, 0, 0, 0.5);" v-if='this.lodging'>{{formatStyle(this.lodging.country.name)}}, {{this.lodging.region.name}}</p>
            <div class="discount-details py-1" v-if="lodging.lodging_description.green_experience_two">
              <img src="../../images/discount.png" class="discount-image" />
              <div class="details">
                <div class="details-1">
                  <span class="merriweather-reg-10">{{ lodging.lodging_description.green_experience_two }}</span>
                </div>
              </div>
            </div>
            <p class="raleway-reg-p15" style="margin-bottom: 0rem;">
              A partir de <span class="raleway-bold-p15">{{ this.lodging.lowest_price}}€/nuit</span>
            </p>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import fetcher from 'packs/shared/api.js';
import Maplodgingshow from 'pages/lodgings/Maplodgingshow.vue';
import CardDiscountBadges from '../shared/CardDiscountBadges.vue';

export default{
  name: 'CardProductHome',
  props: {
    lodging: Object,
    lodgings: Array,
    user: Object,
    wishlist: Object,
    showOnMap: {
      type: Boolean,
      default: false
    },
    showDiscountBadges: {
      type: Boolean,
      default: false
    }
  },
  components: { Maplodgingshow, CardDiscountBadges },
  data() {
    return {
      photo_keys: this.lodging.photos_keys,
      uid: this.user.id,
      lid: this.lodging.id,
      showMap: false,
      markers: [],
      ratedLodgings: [],
      averageList:[],
      average: 0,
      wishlistLodgings: null,
      scrollPosition: 0,
    }
  },
  methods: {
    greenNotePicto(score){
      if (score === `${score}`){
        return require(`../../images/greennote ${score}.svg`)
      } else {
        return require("../../images/blanc.png")
      }
    },
    openInNewWindow(slug, event) {
      event.preventDefault();
      window.open('/reservation-hotel/' + slug, '_blank');
    },
    goToLodging(){
      window.open('/reservation-hotel/' + this.lodging.slug, '_blank');
    },
    displayMap() {
      if (!this.showMap) {
        // Save scroll position before opening map
        this.scrollPosition = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
        // Prevent body scroll when map is open
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
      }
      this.showMap = !this.showMap;
      this.markers = [this.lodging.longitude, this.lodging.latitude];
    },
    closeMap() {
      this.showMap = false;
      // Restore scrolling
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      
      // Restore scroll position with delay and behavior
      this.$nextTick(() => {
        setTimeout(() => {
          window.scrollTo({
            top: this.scrollPosition,
            left: 0,
            behavior: 'auto'
          });
        }, 50);
      });
    },
    formatStyle(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    formatSource() {
      if (this.lodging.photo_banner) {
        return `${this.lodging.photo_banner}`
      } else {
        return "https://media.gettyimages.com/photos/bedroom-in-new-luxury-home-picture-id1194686012?k=6&m=1194686012&s=612x612&w=0&h=IX6Bjhwa5M5NtCtlKll-FFi_hn5lxrPwiUImH3fsZZ0="
      }
    },
    async toggleLike() {
      try {
        if (Object.entries(this.user).length !== 0) {
          const response = await fetcher.patch('/wishlists/'+ this.user.id, { lodging_id: this.lodging.id });
          this.wishlistLodgings = response.data.lodgings;
        } else {
          this.$root.$emit('openModal');
          window.scrollTo({
            top: 0,
            behaviour: 'smooth'
          });
        }
      } catch(e) {
        console.error(e)
      }
    },
    ratedLodging(){
      this.ratedLodgings = this.lodging.reservations?.filter(el => el.rated === true) || [];
      return this.ratedLodgings
    },
    averageRate(){
      this.ratedLodgings.forEach((el) => {
        this.averageList.push(el.rate_average)
      })
      return this.averageList
    },
    averageLodging(){
      if(this.averageList.length !== 0){
        this.average = (this.averageList.reduce((a, b) => a + b, 0) / this.averageList.length).toFixed(1);
        return this.average
      } else {
        return this.average = '-'
      }
    },
    isIncludeInWishlist() {
      if (this.wishlistLodgings) {
        for (const lodging of this.wishlistLodgings) {
          if (lodging.id === this.lodging.id) {
            return true
          }
        }
      }
      return false
    },
  },
  mounted(){
    this.ratedLodging();
    this.averageRate();
    this.averageLodging();
  },
  computed: {
    defineWishlistLodgings() {
      return this.wishlistLodgings = this.wishlist.lodgings
    },
    experienceName() {
      if (this.lodging.experience_name) {
        const words = this.lodging.experience_name.split('\n');
        const firstWord = words.shift();
        const restOfSentence = words.join(' ');
        return [firstWord, restOfSentence];
      } else {
        return null;
      }
    }
  }
}
</script>

<style scoped>
#cardProduct-big-two{
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  width: 100% !important;

  .card-hub-info{
    width: 100%;
  }
  .hub-img{
    width: 100%;
    height: 440px;
    margin-right: 1rem;
    padding-right: 0 !important;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 35.61%, rgba(0, 0, 0, 0.3) 86.31%);
  }
  .hub-header{
    margin-top: 1rem;
    justify-content: space-between;
  }
  .location-hub{
    display: none;
  }
  .catch-hub-phone{
    display: block;
  }
  .catch-hub{
    display: none;
  }
  .reviews-btn{
    display: flex;
    justify-content: space-between;
  }
  .hub-img-zoom{
    margin-top: auto;
    margin-bottom: auto;
    width: 535px;
    height: 440px;
    margin-right: 1rem;
    overflow: hidden;
    cursor: pointer;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    border-radius: 15px;
  }
  .sticker-hub{
    position: absolute;
    background-color: #fff;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    padding-top: 5px;
    padding-bottom: 5px;
    align-items: center;
    z-index: 2;

    img{
      width: 19px;
      height: 28px;
    }
  }
  .sticker-info{
    flex-direction: column;
  }

  .standing{
    img{
      width: 15px;
    }
  }
  .reviews-btn{
    display: flex;
    justify-content: space-between;
    .xs-btn-primary{
      width: 120px;
      height: 49px;
    }
  }
  .hub-reviews{
    img{
      width: 23px;
      height: 27px;
    }
    .review-info{
      flex-direction: column;
    }
  }

  .experience-name-text {
    position: absolute;
    bottom: 10px;
    left: 10px;
    color: #F7F7F7;
    line-height: 110%;
  }
}
@media only screen and (min-device-width : 320px) and (max-device-width : 480px) {
  #cardProduct-big{
    display: flex;
    flex-direction: column;
    width: auto;
    margin: 0 auto;
    .card-hub-info{
      width: 100%;
    }
    .hub-img{
      width: 100%;
      height: 211px;
      padding-right: 1rem;
    }
    .hub-header{
      margin-top: 1rem;
      justify-content: space-between;
      margin-right: 14px;
    }
    .location-hub{
      display: none;
    }
    .catch-hub-phone{
      display: block;
    }
    .catch-hub{
      display: none;
    }
    .reviews-btn{
      display: flex;
      justify-content: space-between;
    }
  }
}

.discount-details {
  display: flex;
  align-items: start;
  justify-items: flex-start;
  img {
    width: 24px;
    height: 28px;
  }

  .details-1 {
    line-height: 100%;
  }
}
.image-gradient-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 27%;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.6), transparent);
  pointer-events: none;
}

.map-area {
  display: flex;
  cursor: pointer;
  align-items: center;
  
  img {
    width: 10px !important;
    height: 12px !important;
  }
}
</style>




<style lang="scss">
  #generic-lodgings-display {
    .card-hub-info {
      width: 334px !important;
    }
  }
</style>